<template>
    <BreadCrumb PageTitle="Modifier un produit Restreint" />
    <EditProduitRestreint/>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import EditProduitRestreint from "@/components/ProduitRestreint/EditProduitRestreint.vue";

export default defineComponent({
    name: "EditProduitRestreintPage",
    components: {
        BreadCrumb,
        EditProduitRestreint,
    },
});
</script>